import React from 'react';

/////Local Shared Types//////
import {E_QuickLinks, LogInType, LogoSize} from 'app/types/Shared';
import smallLogo from 'assets/images/header/elevateLogoSmall.svg';
import takedaLogo from 'assets/images/header/takedaLogo.svg';
/////React Router Dom/////
import {NavLink, useNavigate} from 'react-router-dom';
///Local Components//////
import PageLayout from 'components/PageLayout/PageLayout';
import TopNavigation from 'components/TopNavigation/TopNavigation';
import FAQContent from 'components/FAQ/FAQContent';
import FAQData from 'components/FAQ/FAQData.json';
import FAQDataCRO from 'components/FAQ/FAQDataCRO.json';
import ChangeRole from 'components/ChangeRole/ChangeRole';
import {Breadcrumbs, Box, Link, Grid, Typography, Stack} from '@mui/material';

import {useMatomo} from '@jonkoops/matomo-tracker-react';
import ArtifactQuickLink from 'components/ArtifactQuickLink/ArtifactQuickLink';
import HelpPage from 'components/HelpPage/HelpPage';
import {selectUserPins, selectRecentlyViewed, selectUserType} from 'app/store/users/userSlice';
import {useSelector} from 'react-redux';
import {selectOnboarding} from 'app/store/appState/appStateSlice';

type QuickLinksProps = {
  quicklink: E_QuickLinks;
};

const QuickLinksPage = ({quicklink}: QuickLinksProps) => {
  const navigate = useNavigate();
  const pins = useSelector(selectUserPins);
  const onboarding = useSelector(selectOnboarding);
  const recentlyviewed = useSelector(selectRecentlyViewed);
  const userType = useSelector(selectUserType);

  // Matomo Analytics
  const {trackPageView} = useMatomo();
  React.useEffect(() => {
    trackPageView();
  });

  //Callback for TopNavigation Logo/Home Button
  function navigateHome() {
    navigate('/home');
    return Promise.resolve();
  }

  const onLogout = async () => {
    navigate('/login');
    return Promise.resolve();
  };

  const onSearch = (query?: string) => {
    navigate(`/search?q=${query}`);
    return Promise.resolve();
  };

  const toResources = async () => {
    navigate('/resources');
    return Promise.resolve();
  };

  const SelectedQuickLink = (selected: E_QuickLinks) => {
    switch (selected) {
      case E_QuickLinks.Pinned:
        return <ArtifactQuickLink type={E_QuickLinks.Pinned} data={pins ? pins : []} />;
      case E_QuickLinks.Recent:
        return <ArtifactQuickLink type={E_QuickLinks.Recent} data={recentlyviewed ? recentlyviewed : []} />;
      case E_QuickLinks.Help:
        return <HelpPage onHome={navigateHome} />;
      case E_QuickLinks.Faq:
        return <FAQContent faqData={userType === LogInType.Internal ? FAQData : FAQDataCRO} />;
      default:
        return <></>;
    }
  };

  const header = (
    <TopNavigation
      authorized={true}
      logout={onLogout}
      smallLogo={smallLogo}
      rightLogo={takedaLogo}
      LogoType={LogoSize.Small}
      home={navigateHome}
      search={onSearch}
      toResources={toResources}
      banner={onboarding?.topBanner}
    />
  );

  const footer = <></>;
  return (
    <PageLayout header={header} footer={footer}>
      <Grid
        justifyContent='flex-start'
        alignItems='flex-end'
        container
        direction='row'
        spacing={1}
        px={6}
        marginTop={onboarding?.topBanner ? 7.5 : 2.5}
      >
        <Grid item xs={3}>
          <Breadcrumbs
            sx={{
              '.MuiBreadcrumbs-separator': {
                color: 'primary.main',
              },
            }}
          >
            <Link underline='hover' color='primary.main' component={NavLink} to='/home'>
              Home
            </Link>
            <Typography color='primary.main'>{quicklink}</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={9} minHeight='70px' display='flex' justifyContent='flex-end'>
          <ChangeRole />
        </Grid>
        <Grid item xs={12}>
          <Stack spacing={2} my={2}>
            <Typography variant='h1'>{quicklink}</Typography>
          </Stack>
        </Grid>
      </Grid>
      <Box>{SelectedQuickLink(quicklink)}</Box>
    </PageLayout>
  );
};

export default QuickLinksPage;
